import { Card, CardMedia, CardContent, Typography, Rating, Box } from "@mui/material";
import React, { useState, useEffect, FC } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { IVideo, formatVideoName } from "../../videos/hooks/useFetchVideos";

interface Props {
    onClick: () => void;
    video: IVideo;
    isSelected?: boolean;
}

const VideoCard: FC<Props> = ({ onClick, video, isSelected }) => {
    const [source, setSource] = useState("");
    const [hoverState, setHoverState] = useState<boolean>(false);

    useEffect(() => {
        const url = video.s3Location || video.reviewS3File?.location;
        setSource(url || "");
    }, [video]);

    const formatName = (videoObject: any) => {
        const name = videoObject?.key || videoObject?.title || "";
        return formatVideoName(name);
    };

    const formatSource = (s: any) => {
        let ext = "." + s?.substr(s.lastIndexOf(".") + 1);
        return (s = s?.replace(ext, "_thumbnail.png"));
    };

    return (
        <Card
            sx={{ position: "relative", ":hover": { cursor: "pointer" } }}
            elevation={hoverState ? 10 : 1}
            onMouseOver={() => setHoverState(true)}
            onMouseLeave={() => setHoverState(false)}
            title={formatName(video)}
        >
            <div onClick={onClick}>
                <CardMedia component="img" src={formatSource(source)} style={{ maxHeight: "112px" }} />

                <CardContent>
                    <Typography gutterBottom component="div">
                        {video?.aspect_ratio}
                        <br />
                        {formatName(video)}
                    </Typography>
                    <Typography fontWeight={400} fontSize={14} color="text.secondary">
                        {video.rating && <Rating name="read-only" value={video.rating} precision={0.5} readOnly />}
                    </Typography>
                </CardContent>
            </div>
            {isSelected && (
                <Box
                    position="absolute"
                    right={2}
                    top={2}
                    bgcolor="var(--accent)"
                    display="flex"
                    borderRadius={50}
                    padding={0.2}
                >
                    <CheckIcon style={{ color: "#fff" }} fontSize="small" />
                </Box>
            )}
        </Card>
    );
};

export default VideoCard;
